export enum PanelTitleTypes {
  Display = 'Display',
  Primary = 'Primary',
  Secondary = 'Secondary',
  Subheading = 'Subheading',
}
